import { IconProps } from 'src/utils/icon';

const AlertIcon: React.FC<IconProps> = ({ size = 1, fill = '#FFC700' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 29 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.326393 21.8268C-0.602915 23.389 0.563581 25.3418 2.41968 25.3418H26.5806C28.4403 25.3418 29.6014 23.386 28.6739 21.8268L16.5933 1.51294C15.6635 -0.0499997 13.3348 -0.0471678 12.4067 1.51294L0.326393 21.8268ZM14.5 17.627C15.7791 17.627 16.816 18.6326 16.816 19.873C16.816 21.1135 15.7791 22.1191 14.5 22.1191C13.2209 22.1191 12.184 21.1135 12.184 19.873C12.184 18.6326 13.2209 17.627 14.5 17.627ZM16.6988 9.55342L16.3253 16.194C16.3079 16.5048 16.0429 16.748 15.7221 16.748H13.2779C12.9571 16.748 12.6921 16.5048 12.6747 16.194L12.3012 9.55342C12.2823 9.21777 12.5578 8.93555 12.9044 8.93555H16.0956C16.4422 8.93555 16.7177 9.21777 16.6988 9.55342Z"
      fill={fill}
    />
  </svg>
);

export default AlertIcon;
